import React from 'react';
import { Carousel } from 'react-bootstrap';

import { UseOutletContextPurchase } from '../Purchase';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { ProviderInvoice } from '../../../../models/provider.invoice.model';
import { Expense } from '../../../../models/expense.model';
import { ProviderOrder } from '../../../../models/provider.order.model';
import { navBarHide, navBarShow } from '../../../../tools/nav.bar.tool';

import AppPdfViewer from '../../../../components/element/PdfViewer';

export interface AppPurchaseViewDraftProps {
  record: any | ProviderOrder | ProviderInvoice | Expense,
  vouchers: {list: boolean, value: {name: string, size: number, type: string, view: string, file: any}[], valid: {name: boolean, file: boolean}[]}
};

const AppPurchaseViewDraft: React.FunctionComponent<AppPurchaseViewDraftProps> = ({record, vouchers}) => {
  const {asideMinimize, setAsideMinimize} = UseOutletContextPurchase()
  const {lang} = StateLanguage()

  const executeShowReference = () => {
    navBarShow('button-navbar-aside-minimize')
    setAsideMinimize("on")
  }

  const executeHideReference = () => {
    navBarHide('button-navbar-aside-minimize')
    setAsideMinimize("off")
  }

  return (
    <>
      { record && record.status === "draft" && vouchers.value.length > 0 &&
        <>
          <div id="container-viewer-pdf" className={`flex-column flex-lg-row-auto order-1 order-lg-2 mb-5 mb-lg-0 ${asideMinimize === "off" && "d-none"}`}>
            <div className="card card-flush">
              <div className="card-header pt-3 flex-nowrap">
                <div className="card-title">
                  <h4>{lang.labels.referencePdf}</h4>
                </div>
                <div className="card-toolbar d-none d-lg-flex">
                  <button className="btn btn-sm btn-icon explore-btn-dismiss" type="button" onClick={executeHideReference}>
                    <span className="svg-icon svg-icon-lg-2x">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />
                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              { vouchers.value.length > 1 &&
                <Carousel fade variant="dark" interval={null} wrap={false}>
                  { vouchers.value.map (( (item, index) => { return (
                    <Carousel.Item key={index}>
                      <div className="card-body pt-0">
                        <AppPdfViewer pdf={item.view}></AppPdfViewer>
                      </div>
                    </Carousel.Item>
                  )}))}
                </Carousel>
              }
              {vouchers.value.length === 1 && (() => { return (
                <div className="card-body pt-0">
                  <AppPdfViewer pdf={vouchers.value[0].view}></AppPdfViewer>
                </div>
              )})()}
            </div>
          </div>
          <button className={`explore-toggle btn btn-primary shadow-lg position-fixed transform-90 rounded-top-0 fw-bolder fs-5 px-10 top-50 end-0 ${asideMinimize === "on" && "d-none"}`} type="button" style={{zIndex: 10}} onClick={executeShowReference}> 
            <span>{lang.labels.viewReferencePdf}</span>
          </button>
        </>
      }
    </>
  )
};

export default AppPurchaseViewDraft;
